export const TELEGRAM_BOT_NAME = 'loot_ball_bot'
export const TELEGRAM_APP_NAME = 'my_collection'
export const INVITE_CODE_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const isValidInviteCode = (inviteCode: string | undefined | null): inviteCode is string =>
    typeof inviteCode === 'string' && INVITE_CODE_PATTERN.test(inviteCode)

export const getTelegramAppLink = (startapp?: string) => {
    const base = `https://t.me/${TELEGRAM_BOT_NAME}/${TELEGRAM_APP_NAME}`
    return startapp ? `${base}?startapp=${startapp}` : base
}
